// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rating{display:flex;align-items:center;gap:8px}.rating__value{text-decoration:underline;text-underline-offset:2px}.rating__value_empty{text-decoration:none}.rating-v2__stars{display:flex;gap:8px}", ""]);
// Exports
module.exports = exports;
